/* eslint-disable no-unused-vars */
import React, { forwardRef, useState, useEffect } from "react"
import DatePicker, { CalendarContainer } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import { calendarIconBlack, caretLeftIcon, caretRightIcon  } from "components/Icons"

export default function CADatePicker({ calendarDate, setCalendarDate }) {
  // Add responsive state management
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  // Add window resize listener for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    
    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const years = _.range(2023, (new Date()).getFullYear() + 3, 1)
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]

  const CalendarBtn = forwardRef(({ onClick }, ref) => (
    <button ref={ref} type="button" className="btn btn-light btn-lg rounded-pill ml-2" onClick={onClick}>
      <img src={calendarIconBlack} alt="Calendar" />
    </button>
  ))

  const MyContainer = ({ className, children }) => {
    if (isMobile) {
      return (
        <div
          className="ca-custom-mobile"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-69%, -50%)",
            zIndex: 9999,
            maxWidth: "calc(100vw - 40px)",
            maxHeight: "calc(100vh - 100px)",
            overflow: "auto"
          }}>
          <CalendarContainer className={className}>
            {children}
          </CalendarContainer>
        </div>
      );
    }
    
    return (
      <div className="ca-custom">
        <CalendarContainer className={className}>
          {children}
        </CalendarContainer>
      </div>
    );
  }

  return (
    <DatePicker
      closeOnScroll={!isMobile}
      popperPlacement="bottom-start"
      popperModifiers={isMobile ? {
        preventOverflow: {
          enabled: true,
          boundariesElement: "viewport",
          padding: 10
        },
        flip: {
          enabled: true,
          behavior: ["bottom", "top"]
        },
        offset: {
          enabled: true,
          offset: "0, 5px"
        }
      } : {
        preventOverflow: {
          enabled: true,
          escapeWithReference: false,
          boundariesElement: "viewport",
          padding: 20
        },
        flip: {
          enabled: true,
          behavior: ["bottom-start", "top-start", "bottom-end", "top-end"]
        },
        offset: {
          enabled: true,
          offset: "0, 5px"
        }
      }}
      popperProps={isMobile ? {
        strategy: "fixed"
      } : {
        strategy: "absolute"
      }}
      calendarContainer={MyContainer}
      customInput={<CalendarBtn />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="custom-calendar-header d-flex justify-content-center">
          <button className="anchor-button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button">
            <img src={caretLeftIcon} alt="Previous Month" className="mr-3" />
          </button>
          <select
            value={months[date.getMonth()]}
            onChange={e => changeMonth(months.indexOf(e.target.value))}>
            {months.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <select value={date.getFullYear()} onChange={e => changeYear(e.target.value)}>
            {years.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <button className="anchor-button" onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button">
            <img src={caretRightIcon} alt="Next Month" className="ml-3" />
          </button>
        </div>
      )}
      todayButton="Today"
      selected={calendarDate}
      onChange={date => {
        setCalendarDate(date)
      }} />
  )
}
